import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
    NotificationsState,
    selectHasNewErrorNotifications,
    selectHasNewNotifications,
    selectNewErrorNotificationCount,
    selectNewNotificationCount
} from '../+state/notifications/notification.reducer';
import { NotificationCenterService } from './notification-center.service';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { LetDirective } from '@ngrx/component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';

@Component({
    selector: 'sphere-shell-notification-center-toggle',
    template: `
        <button *ngrxLet="vm$; let vm" mat-icon-button (click)="notificationCenter.toggleNotificationCenter()">
            <mat-icon
                [matBadgeColor]="vm.hasErrorNotifications ? 'warn' : 'primary'"
                [matBadgeHidden]="!vm.hasNewNotifications"
                [matBadge]="vm.newNotificationCount > 9 ? '9+' : vm.newNotificationCount"
                >notifications</mat-icon
            >
        </button>
    `,
    styles: [``],
    imports: [LetDirective, MatIconButton, MatIcon, MatBadge]
})
export class NotificationCenterToggleComponent {
    private store = inject<Store<NotificationsState>>(Store);
    notificationCenter = inject(NotificationCenterService);

    private newNotificationCount$ = this.store.select(selectNewNotificationCount);
    private hasNewNotifications$ = this.store.select(selectHasNewNotifications);
    private newErrorNotificationCount$ = this.store.select(selectNewErrorNotificationCount);
    private hasErrorNotifications$ = this.store.select(selectHasNewErrorNotifications);

    public vm$ = combineLatest([
        this.newNotificationCount$,
        this.hasNewNotifications$,
        this.newErrorNotificationCount$,
        this.hasErrorNotifications$
    ]).pipe(
        map(([newNotificationCount, hasNewNotifications, newErrorNotificationCount, hasErrorNotifications]) => ({
            newNotificationCount,
            hasNewNotifications,
            newErrorNotificationCount,
            hasErrorNotifications
        }))
    );
}
